import { ReactSVG } from "react-svg";
import { Contact } from "services/api/contacts/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

/** Naziv kontakta: osoba ima ime i prezime, tvrtka samo naziv. */
export const getWarehouseContactName = (contact: Contact) =>
  [contact.firstName, contact.lastName].filter(Boolean).join(" ") || contact.companyName || contact.name || "-";

/** Stupci kontakata u čarobnjaku skladišta — isti izgled kao adrese u čarobnjaku kontakta. */
export const WAREHOUSE_EDIT_CONTACT_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Kontakt",
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => {
      return (
        <div>
          <span className="text-md font-medium text-slate-600">{getWarehouseContactName(row)}</span>
          {row.jobTitle && <div className="text-xs text-slate-500">{row.jobTitle}</div>}
        </div>
      );
    },
  },
  {
    title: "Telefon",
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => {
      return <div className="text-sm text-slate-900 truncate">{row.primaryContactPhone?.phoneNumber ?? "-"}</div>;
    },
  },
  {
    title: "Email",
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => {
      return <div className="text-sm text-slate-900 truncate">{row.primaryContactEmail?.emailAddress ?? "-"}</div>;
    },
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => {
      return (
        <div onClick={(e) => handleDeleteClick(e, row.id)} className="flex justify-end items-center h-[30px] cursor-pointer">
          <ReactSVG src={"/media/icons/trash.svg"} className="w-4 h-4 stroke-[#bd0000]" />
        </div>
      );
    },
  },
];
